import '@babel/polyfill';
import 'mutationobserver-shim';
import Vue from 'vue';

import './plugins/bootstrap-vue';
import './plugins/vue-axios';
import './plugins/v-lightbox';

import moment from 'moment';

import App from './App.vue';
import router from './router';

Vue.config.productionTip = false;
Vue.config.devtools = true;

Vue.filter('toCurrency', (value: any) => {
  if (typeof value !== 'number') {
    return value;
  }

  const formatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  });

  return formatter.format(value);
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
